import {
  JSPrintManager,
  WSStatus,
  ClientPrintJob,
  InstalledPrinter,
  PrintFilePDF,
  FileSourceType,
  Sizing,
} from 'jsprintmanager'

export const isConnected = () =>
  JSPrintManager.websocket_status === WSStatus.Open

export const init = () => {
  JSPrintManager.auto_reconnect = true
  JSPrintManager.license_url =
    'https://cloud-apps-01-pub.cttexpress.com/jspm-api/jspm'
  JSPrintManager.start()
}

export const onStatusChanged = callback => {
  if (JSPrintManager?.WS) {
    JSPrintManager.WS.onStatusChanged = callback
  }
}

export const getPrinters = async () => {
  const printers = await JSPrintManager.getPrinters()
  return printers
}

export const printPdf = (printer, pdfString) => {
  try {
    const printJob = new ClientPrintJob()

    printJob.clientPrinter = new InstalledPrinter(printer)

    const pdfFile = new PrintFilePDF(
      pdfString,
      FileSourceType.Base64,
      'MyFile.pdf',
    )

    pdfFile.printAutoRotate = true
    pdfFile.printAutoCenter = true
    pdfFile.pageSizing = Sizing.Fit

    printJob.files.push(pdfFile)

    printJob.sendToClient()
  } catch (err) {
    console.error(err)
  }
}

export const printRawData = (printer, rawData) => {
  try {
    const printJob = new ClientPrintJob()

    printJob.clientPrinter = new InstalledPrinter(printer)

    printJob.binaryPrinterCommands = Uint8Array.from(
      Array.from(rawData).map(char => char.charCodeAt(0)),
    )

    printJob.sendToClient()
  } catch (err) {
    console.error(err)
  }
}
